import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "as-match-list" }

import { computed, ref } from "vue";
import type { IMatch, ITeam, ILeague } from "~src/interfaces/basketball";
import { parseMatchH2hData } from "~src/helpers/basketball";
import ArrowDown from "~src/components/icons/ArrowDown.vue";
import MatchItem from "~src/components/matches/basketball/MatchItem.vue";


const __default__ = {};

interface IProps {
  h2h: Array<Object>;
  teams: Array<ITeam>;
  competitions: Array<ILeague>;
  match: IMatch;
  tab: string;
  isShowFooter: boolean;
  homeTeamId: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'H2hTab',
  props: {
    h2h: {},
    teams: {},
    competitions: {},
    match: {},
    tab: {},
    isShowFooter: { type: Boolean, default: true },
    homeTeamId: {}
  },
  setup(__props: any) {

const props = __props;

const isShowMore = ref(props.h2h?.length > 5 ? false : true);

const rows = computed(() => {
  if (isShowMore.value) {
    return props.h2h;
  }

  return props.h2h?.slice(0, 5);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (item, key) => {
      return (_openBlock(), _createBlock(MatchItem, {
        key: key,
        match: _unref(parseMatchH2hData)(item, _ctx.homeTeamId),
        teams: _ctx.teams,
        competitions: _ctx.competitions,
        isShowFooter: _ctx.isShowFooter,
        isH2h: true
      }, null, 8, ["match", "teams", "competitions", "isShowFooter"]))
    }), 128)),
    (!isShowMore.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowMore.value = true)),
          class: "as-show-more"
        }, [
          _cache[1] || (_cache[1] = _createTextVNode(" Hiển thị thêm trận đấu ")),
          _createVNode(ArrowDown)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})